export default __webpack_public_path__ + "static/media/30.9b7e05b6.png";